import { getMaxWelcomeMessageContainerWidth } from './getAIWelcomeMessageAnimationStyles';

// padding & borders
const PADDING_WIDTH = 2 * 24;
const BORDER_WIDTH = 2 * 2;

// min-width
const MIN_WIDTH = 185;
export const getMaxWidth = (isAIChatBot, isMobile) => {
  return `${getMaxWelcomeMessageContainerWidth(isAIChatBot, isMobile) - PADDING_WIDTH - BORDER_WIDTH}px`;
};
export const getMinWidth = (isAIChatbot, avatarsCount) => {
  if (avatarsCount > 1 && !isAIChatbot) {
    return `${MIN_WIDTH + avatarsCount * 15 - PADDING_WIDTH - BORDER_WIDTH}px`;
  }
  return `${MIN_WIDTH - PADDING_WIDTH - BORDER_WIDTH}PX`;
};